/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReinsuredResponseDto } from './ReinsuredResponseDto';
import {
    ReinsuredResponseDtoFromJSON,
    ReinsuredResponseDtoFromJSONTyped,
    ReinsuredResponseDtoToJSON,
    ReinsuredResponseDtoToJSONTyped,
} from './ReinsuredResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface ReinsuredPaginationResponseDto
 */
export interface ReinsuredPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof ReinsuredPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<ReinsuredResponseDto>}
     * @memberof ReinsuredPaginationResponseDto
     */
    items: Array<ReinsuredResponseDto>;
}

/**
 * Check if a given object implements the ReinsuredPaginationResponseDto interface.
 */
export function instanceOfReinsuredPaginationResponseDto(value: object): value is ReinsuredPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ReinsuredPaginationResponseDtoFromJSON(json: any): ReinsuredPaginationResponseDto {
    return ReinsuredPaginationResponseDtoFromJSONTyped(json, false);
}

export function ReinsuredPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReinsuredPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(ReinsuredResponseDtoFromJSON)),
    };
}

export function ReinsuredPaginationResponseDtoToJSON(json: any): ReinsuredPaginationResponseDto {
    return ReinsuredPaginationResponseDtoToJSONTyped(json, false);
}

export function ReinsuredPaginationResponseDtoToJSONTyped(value?: ReinsuredPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(ReinsuredResponseDtoToJSON)),
    };
}

